import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/portfolio/medical-imaging-analysis/page.tsx");
